module.exports = __webpack_public_path__ + "img/wireless-speaker.28998ea5.svg";